module.exports = __webpack_public_path__ + "media/explosion.f18500be.ogg";